import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BlockedDomain } from '../domain/bd/blocked-domain.model';
import { Page } from '../domain/page.model';
import { DPBlockedDomain } from '../domain/bd/dp-blocked-domain.model';
import { HttpUtils } from '../utils/http-utils';
import { Publisher } from '../domain/publisher.model';
import { DemandPartner } from '../domain/demand-partner.model';
import { BlockedDomainListRequest } from '../../kitchen/shared/domain/bd/blocked-domain-list-request.model';
import { BlockedDomainRequest } from '../../kitchen/shared/domain/bd/blocked-domain-request.model';


@Injectable()
export class AdStatsBlockedDomainsService {
  constructor(private http: HttpClient) {
  }

  confiantImport(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${environment.serviceUrl}/ad-stats/blocked-domains/confiantcsv`, formData);
  }

  blockedDomainsSendEmails(bds: DPBlockedDomain[]) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/blocked-domains/sendemails`, bds);
  }

  createBlockedDomains(bds: BlockedDomain[], addToConfiant = false): Observable<BlockedDomain[]> {
    return this.http.post<BlockedDomain[]>(`${environment.serviceUrl}/ad-stats/blocked-domains/multi`, bds, {
      params: HttpUtils.getHttpParams({
        addToConfiant: addToConfiant
      })
    });
  }

  blockedDomainsDelete(bds: BlockedDomain[], comment?: string) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/blocked-domains/multi/delete`, {
      ids: bds.map(d => d.id),
      comment: comment
    });
  }

  getBlockedDomains(params: BlockedDomainListRequest): Observable<Page<BlockedDomain>> {
    return this.http.get<Page<BlockedDomain>>(`${environment.serviceUrl}/ad-stats/blocked-domains`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

  getBlockedDomainsExport(params: BlockedDomainListRequest) {
    return this.http.get(`${environment.serviceUrl}/ad-stats/blocked-domains/export`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams(params)
    });
  }

  getBlockedDomainsPublishers(params: BlockedDomainRequest): Observable<Page<Publisher>> {
    return this.http.get<Page<Publisher>>(`${environment.serviceUrl}/ad-stats/blocked-domains/publishers`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

  getBlockedDomainsDemandPartners(params: BlockedDomainRequest): Observable<Page<DemandPartner>> {
    return this.http.get<Page<DemandPartner>>(`${environment.serviceUrl}/ad-stats/blocked-domains/demand-partners`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

  getBlockedDomainsDemandPartnersStats(dateFrom: string, dateTo: string): Observable<DpBlockedDomainExt[]> {
    return this.http.get<DpBlockedDomainExt[]>(`${environment.serviceUrl}/ad-stats/blocked-domains/demand-partners/stats`, {
      params: HttpUtils.getHttpParams({
        dateFrom, dateTo
      })
    });
  }

  dpBlockedDomainUpdate(dps: DPBlockedDomain[]): Observable<DPBlockedDomain[]> {
    return this.http.put<DPBlockedDomain[]>(`${environment.serviceUrl}/ad-stats/blocked-domains/dp`, dps);
  }
}

export class DpBlockedDomainExt extends DPBlockedDomain {
  totalImpressions: number;
}
